import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import { RentCalc, CreditCardCalc, MortgageCalc, RetirementCalc, DebtInvestCalc, RaiseCalc, MillionaireCalc } from './pages/Calculators';
import CurrencyConverter from './pages/CurrencyConverter';
import SavingsGrowthCalc from './pages/SavingsGrowth';
import SEO, { PAGE_SEO } from './components/SEO';
import PrivacyPolicy from './pages/PrivacyPolicy';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppInner() {
  const [currency, setCurrency] = useState('USD');
  return (
    <>
      <Navbar currency={currency} onCurrencyChange={setCurrency} />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<><SEO {...PAGE_SEO.home} /><Home /></>} />
        <Route path="/rent" element={<><SEO {...PAGE_SEO.rent} /><RentCalc currency={currency} /></>} />
        <Route path="/credit-card" element={<><SEO {...PAGE_SEO['credit-card']} /><CreditCardCalc currency={currency} /></>} />
        <Route path="/mortgage" element={<><SEO {...PAGE_SEO.mortgage} /><MortgageCalc currency={currency} /></>} />
        <Route path="/retirement" element={<><SEO {...PAGE_SEO.retirement} /><RetirementCalc currency={currency} /></>} />
        <Route path="/debt-invest" element={<><SEO {...PAGE_SEO['debt-invest']} /><DebtInvestCalc currency={currency} /></>} />
        <Route path="/raise" element={<><SEO {...PAGE_SEO.raise} /><RaiseCalc currency={currency} /></>} />
        <Route path="/millionaire" element={<><SEO {...PAGE_SEO.millionaire} /><MillionaireCalc currency={currency} /></>} />
        <Route path="/currency" element={<><SEO {...PAGE_SEO.currency} /><CurrencyConverter /></>} />
        <Route path="/savings-growth" element={<><SEO {...PAGE_SEO['savings-growth']} /><SavingsGrowthCalc currency={currency} /></>} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}
